import React from 'react';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import {
  withStyles,
} from '@material-ui/core';
import { get } from 'lodash';
import queryString from 'query-string';
import { func, shape, string } from 'prop-types';

import LdapProviderConfiguration from './Ldap';
import OldSamlLdapProviderConfiguration from './OldSaml';
import SamlProviderConfiguration from './Saml';
import JwtProviderConfiguration from './Jwt';
import {
  SAML_OLD,
  SAML,
  LDAP,
  JWT,
} from '../label';
import styles from '../styles';

export const ProviderConfiguration = (props) => {
  const {
    classes,
    errors,
    authDetails,
    notifyMessages,
    tabValue,
    onCancelDetails,
    push,
  } = props;

  const uuid = get(props, 'match.params.authUuid');
  const queryParam = queryString.parse(props.location.search);
  const authParamType = get(queryParam, 'authType');

  return(
    <div id="auth-settings-root-provider-container" className={classes.pageContainer}>
      { authParamType === LDAP &&
        <LdapProviderConfiguration
          {...props}
          errors={errors}
          authDetails={authDetails}
          uuid={uuid}
          notifyMessages={notifyMessages}
          tabValue={tabValue}
          onCancelDetails={onCancelDetails}
          push={push}
        />
      }
      {authParamType === SAML_OLD &&
        <OldSamlLdapProviderConfiguration
          {...props}
          errors={errors}
          authDetails={authDetails}
          uuid={uuid}
          notifyMessages={notifyMessages}
          tabValue={tabValue}
          onCancelDetails={onCancelDetails}
          push={push}
        />
      }
      {authParamType === SAML &&
        <SamlProviderConfiguration
          {...props}
          errors={errors}
          authDetails={authDetails}
          uuid={uuid}
          notifyMessages={notifyMessages}
          tabValue={tabValue}
          onCancelDetails={onCancelDetails}
          push={push}
        />
      }
      {authParamType === JWT &&
        <JwtProviderConfiguration
          {...props}
          errors={errors}
          authDetails={authDetails}
          uuid={uuid}
          notifyMessages={notifyMessages}
          tabValue={tabValue}
          onCancelDetails={onCancelDetails}
          push={push}
        />
      }
    </div>
  );
}

ProviderConfiguration.propTypes = {
  classes: shape({}),
  authDetails: shape({}),
  errors: shape({}),
  notifyMessages: func,
  tabValue: string,
  location: shape({}),
  onCancelDetails: func,
  push: func,
};
  
const mapStateToProps = () => ({
});

const mapDispatchToProps = {
};

export default compose(
withStyles(styles),
connect(mapStateToProps, mapDispatchToProps),
)(ProviderConfiguration);